import { render } from "./BufferSchemaView.vue?vue&type=template&id=21bbad80&scoped=true"
import script from "./BufferSchemaView.vue?vue&type=script&lang=js"
export * from "./BufferSchemaView.vue?vue&type=script&lang=js"

import "./BufferSchemaView.vue?vue&type=style&index=0&id=21bbad80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bbad80"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QPopupProxy,QBanner,QIcon});
